import { useRef, createRef } from "react";
import {
  CustomFilterUnion,
  CustomFilterConfig,
  CFChangeEvent,
  CFCheckBoxItemSetting,
} from "./types";
import { f } from "../../../util/f";
import InputCheckbox from "../../formcontrols/InputCheckbox";
import { random } from "lodash";

export default function CustomFilterCheckBoxItem<
  C extends CustomFilterUnion,
>(props: {
  config: CustomFilterConfig<C>;
  filterEvent: (event: CFChangeEvent) => void;
  settings: CFCheckBoxItemSetting[];
}) {
  // destruction!
  const { config, filterEvent, settings } = props;

  const values =
    config.component.type === "checkbox" ? config.component.values : [];

  // reffys
  const inputRefs = useRef(
    [...Array(values.length)].map(() => createRef<HTMLInputElement>()),
  );

  // handler
  function checkEventHandler() {
    // get all refs
    const refValues = inputRefs.current.flatMap((r) => {
      if (r.current) {
        if (r.current.checked) {
          return r.current?.id;
        } else {
          return [];
        }
      } else {
        return [];
      }
    });

    // remove id's from values
    const cleanValues = refValues.map((val) =>
      val.substring(0, val.indexOf("__")),
    );

    let onlyNullValue = false;
    if (cleanValues.length === 1 && cleanValues[0] === "null") {
      onlyNullValue = true;
    }

    const filterStr =
      refValues.length > 0
        ? f<any>()
            .addFilter(
              config.queryKey,
              onlyNullValue
                ? {
                    eq: null,
                  }
                : {
                    in: cleanValues,
                  },
            )
            .build()
        : "";

    const filterObj =
      cleanValues.length > 0
        ? onlyNullValue
          ? { [config.queryKey]: { eq: null } }
          : { [config.queryKey]: { in: cleanValues } }
        : {};

    const filterSettings: CFCheckBoxItemSetting[] = cleanValues.map((val) => {
      return {
        value: val,
      };
    });

    const event: CFChangeEvent = {
      filterString: filterStr,
      filterObj: filterObj,
      filterSettings: filterSettings,
    };

    filterEvent(event);
  }

  return (
    <div className="c-custom-filter__content">
      {values.map((v, index) => {
        return (
          <InputCheckbox
            id={`${v.value}__${random(0, 1000)}`}
            label={v.displayName}
            defaultChecked={settings?.some((set) => set.value === v.value)}
            key={v.value}
            ref={inputRefs.current[index]}
            onChange={() => {
              checkEventHandler();
            }}
          />
        );
      })}
    </div>
  );
}
